<aside class="sidebar-account" #container [ngClass]="{'slide-menu-active': showMenu}" (click)="toggleMenu()">
  <div (click)="$event.stopImmediatePropagation();" class="wrapper-menu" [ngClass]="{'wrapper-menu-active': showMenu}">
    <div class="sidebar-account-menu">
      <div class="header-sidebar">
        <img src="./assets/images/core/icone-unico.svg" alt="unico | people" width="40" height="40">
        <button type="button" aria-label="Fecha menu lateral" (click)="toggleMenu()"></button>
      </div>
      <div class="sidebar-menu first">
        <h3>Empresa</h3>
        <ul>
            <li class="open-companies-container">
                <button class="open-companies-mini" type="button" (click)="toggleTab('settings')"  attr.aria-label="Abrir aba de empresas da {{acc?.name}}." data-test="btnOpenListCompanies">
                    <span class="current-company-mini-image" [attr.data-name]="acc?.name | slice:0:1">
                        <img *ngIf="acc?.customFields?.brand !== null" src="{{url}}/t/100x100,q100/{{acc?.customFields?.brand?.path}}" alt="Logo da empresa">
                    </span>
                    <p class="current-company-mini-title" title="{{acc?.name}}">{{acc?.name}}</p>
                </button>
            </li>
            <li>
                <a href="{{adminUrl}}" (click)="toggleMenu('candidate')" class="ico-admission" aria-label="Ir para listagem de candidatos." data-test="linkAdmissionDashboard">Admissão</a>
            </li>
            <li *ngIf="hasCollaborators">
              <details class="collapse">
                <summary class="title ico-colaborators" data-test="infoTitleModalRulesDetails">
                  <p>
                    Colaboradores
                  </p>
                </summary>
                <ul>
                  <li>
                    <a href="{{collaboratorUrl}}" (click)="toggleMenu('listing')" aria-label="Ir para a listagem de colaboradores." data-test="linkOngoingDashboard">Listagem</a>
                  </li>
                  <li *ngIf="enableCollaboratorsRequestSidebar">
                    <a href="{{collaboratorUrl + '/requests'}}" area-label="Ir para listagem de solicitações">Solicitações</a>
                  </li>
                  <li>
                    <a href="{{collaboratorUrl + '/new'}}" (click)="toggleMenu('import')" aria-label="Ir para importar colaboradores." data-test="linkOngoingDashboardImportEmployee">Importação</a>
                  </li>
                  <li>
                    <a href="{{collaboratorUrl + '/processing-status'}}" (click)="toggleMenu('history')" aria-label="Ir para histórico de importação." data-test="linkOngoingDashboardProcessingEmployee">Histórico de Importação</a>
                  </li>
                </ul>
              </details>
            </li>
            <li *ngIf="enableEnvelopesManagement" data-test="menu_item_signatures">
              <details class="collapse">
                <summary class="title ico-signatures">
                  <p>Assinaturas</p>
                </summary>
                <ul>
                  <li>
                    <a href="{{baseUrl + '/signatures'}}" (click)="toggleMenu()" aria-label="Ir para gestão de assinaturas" class="link">
                      <img src="/assets/images/core/ic-mail.svg" alt="Gestão de envelopes" data-test="subscription_management">
                      Gestão de assinaturas
                    </a>
                  </li>
                  <li>
                    <a *ngIf="!enableNewModelsList" href="{{baseUrl + '/company/models'}}" (click)="toggleMenu()" aria-label="Ir para gestão de modelos" class="link">
                      <img src="/assets/images/core/ic-files.svg" alt="Listar modelos" data-test="model_management">
                      Gestão de modelos
                    </a>

                    <a *ngIf="enableNewModelsList" href="{{baseUrl + '/company/models-list'}}" (click)="toggleMenu()" aria-label="Ir para gestão de modelos" class="link">
                      <img src="/assets/images/core/ic-files.svg" alt="Listar modelos" data-test="model_management">
                      Gestão de modelos
                    </a>
                  </li>
                </ul>
              </details>
              </li>
            <li>
            <li>
                <a href="{{baseUrl + '/company'}}" (click)="toggleMenu()" aria-label="Ir para as configurações da empresa." data-test="linkAdmissionSettings" class="ico-settings">Configurações</a>
            </li>
            <li *ngIf="showBenefitsProductivity">
              <a routerLink="/productivity" (click)="toggleMenu()" aria-label="Ir para produtividade." class="ico-productivity">Produtividade</a>
            </li>

        </ul>
      </div>
      <div class="sidebar-menu" *ngIf="hasSignature">
              <h3>Grupo</h3>
              <ul>
                <li>
                  <a *ngIf="hasSignature && !flagActiveModelsListModule" href="{{singUrl}}" aria-label="Ir para Assinatura Eletrônica" class="ico-sign">Assinatura Eletrônica</a>
                  <a *ngIf="hasSignature && flagActiveModelsListModule" href="{{singUrl}}" aria-label="Ir para as configurações da empresa." class="ico-sign">Unico Sign</a>
                </li>
              </ul>
      </div>
    </div>
    <div class="sidebar-company-submenu sidebar-submenu" [ngClass]="{'open' : company }" *ngIf="company">
        <up-ui-companies-sidebar [companies]="list" [acc]="acc?.uid" (change)="changeCompany($event)"></up-ui-companies-sidebar>
    </div>
  </div>
</aside>
